import React from 'react';
import 'twin.macro';

export const TableBody = ({ children }) => <tbody tw='divide-y divide-icons'>{children}</tbody>;
